import { supabase } from './supabase';

export interface UserProfile {
  id: string;
  email: string;
  name: string;
  avatar_url?: string;
  provider: 'google' | 'email';
}

export async function signInWithGoogle() {
  const targetRedirect = typeof window !== 'undefined' ? `${window.location.origin}/owner` : 'https://zhasearch.com/owner';
  const { data, error } = await supabase.auth.signInWithOAuth({
    provider: 'google',
    options: {
      redirectTo: targetRedirect
    }
  });

  if (error) {
    console.error('Google Auth Error:', error.message);
    throw error;
  }
  return data;
}

// Sign out session
export async function signOutUser() {
  await supabase.auth.signOut();
  localStorage.removeItem('localhub_user_session');
}

// Get current session or stored Google user profile
export function getCurrentUserProfile(): UserProfile | null {
  try {
    const cached = localStorage.getItem('localhub_user_session');
    if (cached) {
      return JSON.parse(cached);
    }
  } catch (e) {}
  return null;
}
